import { TargetAndTransition } from 'framer-motion';

// The ellipse (3W x 2H, rests above the block) travels 55% of its height down; the fill
// layer (W x H) counter-travels so the gradient stays still while the ellipse reveals it.
export type tTimeoutBlockPart = 'ellipse' | 'fill';

const ELLIPSE_FULL_TRAVEL_PERCENT = 55;
// Resume offset per unit of elapsed progress, same mapping the clip-path version used.
const ELLIPSE_TRAVEL_PER_PROGRESS_PERCENT = 50;
const FILL_PER_ELLIPSE_PERCENT = -2;

export const HIDDEN_TIMEOUT_BLOCK_POSITION = { y: '0%' };

export function buildTimeoutBlockAnimation(progress: number, durationSeconds: number) {
  return (part: tTimeoutBlockPart): TargetAndTransition => {
    const factor = part === 'ellipse' ? 1 : FILL_PER_ELLIPSE_PERCENT;

    return {
      y: [
        `${progress * ELLIPSE_TRAVEL_PER_PROGRESS_PERCENT * factor}%`,
        `${ELLIPSE_FULL_TRAVEL_PERCENT * factor}%`
      ],
      transition: { duration: durationSeconds, ease: 'linear' }
    };
  };
}
